import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import Link from 'components/shared/Link'
import { LinkVariant } from 'styles/types'
import { ImageInfoBoxWrapper } from './styles'

interface ImageInfoBoxProps {
    image: string
    imageAlt: string
    title: Record<string, string>
    desc: Record<string, string>
    linkText: Record<string, string>
    linkUrl?: string
    linkVariant?: LinkVariant
    hasExtraSpace?: boolean
    testId?: string
}

const ImageInfoBox = ({
    image,
    imageAlt,
    title,
    desc,
    linkText,
    linkUrl,
    linkVariant = 'secondary',
    hasExtraSpace,
    testId,
}: ImageInfoBoxProps) => (
    <ImageInfoBoxWrapper gap={24} direction={['column', 'row']} isFullWidth>
        <Box>
            <img src={image} alt={imageAlt} />
        </Box>
        <Box pt={[0, 24]} pb={24} pl={[16, 0]} pr={[16, 0]}>
            <Text variant="heading3" pb={12}>
                <FormattedMessage {...title} />
            </Text>
            <Text variant="body" pb={16} color="grayscale_900">
                <FormattedMessage {...desc} />
            </Text>
            {hasExtraSpace && <br />}
            <Link variant={linkVariant} path={linkUrl} data-testid={testId}>
                <FormattedMessage {...linkText} />
            </Link>
        </Box>
    </ImageInfoBoxWrapper>
)

export default ImageInfoBox
